<template lang="pug">	
	.ai-music--styles-library
		.space(:class="[ isHorizontal ? 'flex-row' : 'flex-col']")
			.flex-row.align-center.center.ai-music-button.clickable(@click="show")
				fas(icon="magnifying-glass")
			.flex-row.align-center.center.ai-music-button.clickable(@click="addNew")
				fas(icon="plus")
		Popup(v-if="itemsPopupVisible", :popupVisible.sync="itemsPopupVisible", :width="640", :autosize="true")
			ListView.full-width(ref="listView", :topPagerVisible="false", :showColumnHeaders="false", initialView="table", :columns="dropdownColumns",
				:width="680", :height="420", :searchVisible="true", :hideViewsSelection="true", :getTotal="(r) => r.TotalNumberOfRecords",
				:getItems="(r) => r.Results", :getData="loadData")
				.font-big.upper.grey(slot="left-actions") {{$tCaption('Styles library')}}
				template(v-slot:displayValue="{ data }")
					.flex-row.justify.align-top
						.flex-col.space.clickable.hoverable.wrap(@click="selectItem(data)")
							span {{data.Name}}
						.flex-row.space.align-center
							DxButton(@click="$confirm(void 0, $tCaption('Remove style from library?')).then(() => remove(data))", icon="trash", type="danger", stylingMode="text")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", @click="itemsPopupVisible = false")
		Popup(v-if="newItemPopupVisible", :popupVisible.sync="newItemPopupVisible", :title="$tCaption('Add new style to library')", :width="640", :autosize="true")
			.flex-col.space-medium
				.flex-col.space
					.font-small {{$tCaption('Name')}}
					DxTextBox(:value.sync="newItem.Name", valueChangeEvent="input", stylingMode="filled")
				.flex-col.space
					.font-small {{$tCaption('Style')}}
					DxTextArea(:value.sync="newItem.Style", valueChangeEvent="input", stylingMode="filled", :height="80")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="newItemPopupVisible = false")
				DxButton(:text="$tCaption('Save', '@actions')", @click="save", :disabled="!newItem.Name || !newItem.Style", type="success")
</template>

<script>
	import Loader from 'app-core/Loader.vue';
	import DxDropDownButton from 'devextreme-vue/drop-down-button';
	import ListView from 'app-core/ListView.vue';
	import Popup from 'app-core/Popup.vue';
	import DxTextArea from 'devextreme-vue/text-area';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxButton from 'devextreme-vue/button';

	export default {
		translationCategory: 'aiMusic.StylesLibrary',
		name: 'ai-music--styles-library',
		components: { Loader, DxDropDownButton, ListView, Popup, DxTextArea, DxButton, DxTextBox },
		props: ['currentStyle', 'isHorizontal'],
		data() {
			return {
				dropdownColumns: [{ dataField: 'Name', cellTemplate: 'displayValue' }],
				dropdownItems: [{ template: 'dropdownTemplate' }],
				newItemPopupVisible: false,
				newItem: {
					Oid: null,
					Name: null,
					Style: null
				},
				itemsPopupVisible: false
			};
		},
		computed: {
			
		},
		watch: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.stylesLibrary = this;
		},
		destroyed() {
			
		},
		methods: {
			show() {
				this.itemsPopupVisible = false;
				this.$nextTick(() => this.itemsPopupVisible = true);
			},
			loadData(pageIndex, limit, opts) {
				if (opts && opts.byKey)
					return this.$Data.getExternalApi('AiMusicStyle/Get', `id=${opts.byKey}`).then(r => ({ Results: r }));
				if (opts?.searchString) {
					opts.filter = ['Name', 'contains', opts.searchString];
				}
				let filterCriteria = `${opts && opts.filter && opts.filter.length && `&filterCriteria=${encodeURIComponent(JSON.stringify(opts.filter))}` || ''}`;
				return this.$Data.getExternalApi('AiMusicStyle/List', `page=${pageIndex + 1}${filterCriteria}&sorting=[{ selector: 'Name' }]`, limit);
			},
			addNew() {
				this.newItem.Name = null;
				this.newItem.Style = this.currentStyle;
				this.newItem.Oid = null;
				this.newItemPopupVisible = false;
				this.$nextTick(() => this.newItemPopupVisible = true);
			},
			save() {
				this.newItemPopupVisible = false;
				this.$Data.postExternalApi('AiMusicStyle/CreateUpdate', this.newItem).then(() => {
					this.$notifySuccess(this.$tCaption('Style saved'));
					if (this.$refs.listView)
						this.$refs.listView.reload();
				});
			},
			remove(item) {
				this.$Data.postExternalApi('AiMusicStyle/Delete', [item.Oid]).then(() => {
					if (this.$refs.listView)
						this.$refs.listView.reload();
				});
			},
			selectItem(item) {
				this.$emit('select', item?.Style || item?.Name);
				this.itemsPopupVisible = false;

				if (__DEBUG__)
					console.debug('Select item', { item });
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.ai-music--styles-library {
	}
</style>
 